import { BATHROOM_CDN_PATH } from '../../../bathroom-constants';

export type NewBathroomCollection = {
  discount: number;
  productId: number;
  title: string;
  description: string;
  img: {
    src: string;
    alt: string;
  },
  href: string;
};

export const SHOW_ALL_LINK = '/promo/nabory-mebeli-dlya-vannoy/?offer=skidka-na-komplekty-dlya-vannoy-komnaty';

export const NEW_BATHROOM_COLLECTION_LIST: NewBathroomCollection[] = [
  {
    discount: 0.1,
    productId: 30008909,
    title: 'Набор Milk',
    description: '4 товара',
    img: {
      src: `${BATHROOM_CDN_PATH}/collections/milk.jpg/milk-01.jpg`,
      alt: 'Фото комплекта Милк',
    },
    href: '/promo/nabory-mebeli-dlya-vannoy/nabor-mebeli-milk-gloriya/',
  },
  {
    discount: 0.1,
    productId: 30008911,
    title: 'Набор «Терни»',
    description: '4 товара',
    img: {
      src: `${BATHROOM_CDN_PATH}/collections/terni.jpg/terni-01.jpg`,
      alt: 'Фото комплекта Терни',
    },
    href: '/promo/nabory-mebeli-dlya-vannoy/nabor-mebeli-terni-levaya/',
  },
  {
    discount: 0.1,
    productId: 30008913,
    title: 'Набор Black',
    description: '2 товара',
    img: {
      src: `${BATHROOM_CDN_PATH}/collections/black.jpg/black-01.jpg`,
      alt: 'Фото комплекта Блэк',
    },
    href: '/promo/nabory-mebeli-dlya-vannoy/nabor-dlya-dushevoy-kvadrat-80x80-kvadro-black/',
  },
  {
    discount: 0.1,
    productId: 30008914,
    title: 'Набор «Квадро»',
    description: '2 товара',
    img: {
      src: `${BATHROOM_CDN_PATH}/collections/square.jpg/square-01.jpg`,
      alt: 'Фото комплекта Квадро',
    },
    href: '/promo/nabory-mebeli-dlya-vannoy/nabor-dlya-dushevoy-kvadrat-90x90-kvadro-hrom/',
  }
];
